import React from 'react';
import PropTypes from 'prop-types';
import { isEmpty, pluck, difference, head } from 'ramda';

import PaymentPresenter, {
  TYPES,
} from '../../../../../../../../presenters/Membership/PaymentPresenter';
import { initialValues } from '../../../../../../../../forms/paymentForm';

import PaymentCell from './components/PaymentCell';
import NewPaymentForm from './components/NewPaymentForm';

const PaymentsTable = (props) => {
  const { payments, membershipId, onDialogOpen, onPaymentCreate } = props;

  const currentPaymentTypes = pluck(['paymentType'], payments);
  const availablePaymentTypes = difference(TYPES, currentPaymentTypes);

  const handleCreatePayment = (values) => {
    const paymentType = values.paymentType;
    const paymentParams = { payment: { paymentType } };
    onPaymentCreate(membershipId, paymentParams);
  };

  return (
    <div>
      <table className="payments-table">
        <thead>
          <tr>
            <th className="cell">Amount</th>
            <th className="cell">State</th>
            <th className="cell">Payment type</th>
            <th className="cell">Created at</th>
            <th className="cell">Actions</th>
          </tr>
        </thead>
        <tbody>
          {payments.map((payment) => (
            <PaymentCell
              key={PaymentPresenter.id(payment)}
              payment={payment}
              onDeleteDialogOpen={onDialogOpen}
            />
          ))}
          {!isEmpty(availablePaymentTypes) && (
            <NewPaymentForm
              onSubmit={handleCreatePayment}
              initialValues={initialValues({
                paymentType: head(availablePaymentTypes),
              })}
              availablePaymentTypes={availablePaymentTypes}
            />
          )}
        </tbody>
      </table>
    </div>
  );
};

export default PaymentsTable;

PaymentsTable.propTypes = {
  payments: PropTypes.arrayOf(PaymentPresenter.shape()).isRequired,
  membershipId: PropTypes.string.isRequired,
  onDialogOpen: PropTypes.func.isRequired,
  onPaymentCreate: PropTypes.func.isRequired,
};
